import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Role } from 'src/app/services/jsonrpc/user-server.service';

@Component({
  selector: 'role-selector',
  templateUrl: './role-selector.component.html',
  styleUrls: ['./role-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: RoleSelectorComponent
    }
  ]
})
export class RoleSelectorComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() public selection: string[];
  @Input() public roles: Role[];

  @Output() public onSelect = new EventEmitter<string[]>();

  public rolesGrouped: Role[][] = [];

  private onChange = roles => {};

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.groupRolesForTable();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.groupRolesForTable();
  }

  writeValue(obj: any): void {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState?(isDisabled: boolean): void {}

  public setSelected(role: string, flag: boolean): void {
    if (!this.selection) this.selection = [];

    const index = this.selection.indexOf(role);
    if (flag && index < 0) {
      this.selection.push(role);
      this.onSelect.emit(this.selection);
      this.onChange(this.selection);
    } else if (!flag && index >= 0) {
      this.selection.splice(index, 1);
      this.onSelect.emit(this.selection);
      this.onChange(this.selection);
    }
  }

  public isSelected(role: string): boolean {
    return this.selection && this.selection.indexOf(role) >= 0;
  }

  private groupRolesForTable(): void {
    const columns = window.innerWidth < 450 ? 1 : 2;
    const groups = Math.ceil(this.roles.length / columns);
    const grp: Role[][] = [];
    let row: Role[] = [];
    this.roles.forEach(r => {
      row.push(r);
      if (row.length >= groups) {
        grp.push(row);
        row = [];
      }
    });
    if (row.length > 0) {
      grp.push(row);
    }
    this.rolesGrouped = grp;
  }
}
